import { TimeZoneService } from "src/app/services/time-zone.service";

export class TimeDiffCalc {

  constructor(private timezoneservice:TimeZoneService){ }

  processRelativeTime(time:any){
    const currentusertime = this.timezoneservice.getcurrentuserTime();
    if(time[1]== -1){
      if(time[2]=='D'){
        const previousdate = currentusertime.clone().subtract(time[0], 'days');
        return [previousdate.set({'hour':0,'minute':0,'second':0}).format('YYYY-MM-DD HH:mm:ss'),currentusertime.format('YYYY-MM-DD HH:mm:ss')];
      }else if(time[2]=='w'){
        const previousdate = currentusertime.clone().subtract(time[0],'weeks');
        return [previousdate.startOf('week').format('YYYY-MM-DD HH:mm:ss'),previousdate.endOf('week').format('YYYY-MM-DD HH:mm:ss')]
      }else if(time[2]=='m'){
        const previousdate = currentusertime.clone().subtract(time[0],'months');
        const enddate = currentusertime.clone().subtract(1,'months');
        return [previousdate.startOf('month').format('YYYY-MM-DD HH:mm:ss'),enddate.endOf('month').format('YYYY-MM-DD HH:mm:ss')];
      }else if(time[2]=='q'){
        const quarter = Math.floor((currentusertime.month()/3));
        const previousdate = currentusertime.clone().set({month:quarter*3,date:1,hour:0,minute:0,second:0})
        const startdate = previousdate.clone().subtract(time[0],'day');
        let enddate = this.timezoneservice.setcurrentuserTime(previousdate.clone().subtract(1,'second'))
        return [startdate.clone().startOf('M').format('YYYY-MM-DD HH:mm'),enddate.format('YYYY-MM-DD HH:mm')];
      }
      
    }else if(time[1]== 0){
      if(time[2]=='m'){
        return [currentusertime.clone().startOf('month').format('YYYY-MM-DD HH:mm:ss'),currentusertime.format('YYYY-MM-DD HH:mm:ss')];
      }
      else if(time[2]=='w') {
        return [currentusertime.clone().startOf('week').format('YYYY-MM-DD HH:mm:ss'),currentusertime.format('YYYY-MM-DD HH:mm:ss')];

      }
      else if(time[2] == 'q'){
        const quarter = Math.floor((currentusertime.month()/3));
        const previousdate = currentusertime.clone().set({month:quarter*3});
        return [previousdate.startOf('month').format('YYYY-MM-DD HH:mm:ss'),currentusertime.format('YYYY-MM-DD HH:mm:ss')];
      }
    }
  }

  gettimerange(timerange:any){
    return {"timerange":timerange.values['timerange'],usertimerange : timerange.values['usertimerange']}
  }

  diffMonths(sDate:any,eDate:any) {
    let monthDiff = (12 * (eDate.year() - sDate.year()));;
    monthDiff -= sDate.month();
    monthDiff += eDate.month();
    return monthDiff + 1
  }

}